import React from 'react';
import { Spin } from 'antd';

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large';
  tip?: string;
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'large', 
  tip = '加载中...', 
  fullScreen = false 
}) => {
  const containerClass = fullScreen ? 'loading-full-screen' : 'loading-container';

  return (
    <div className={containerClass}>
      <Spin size={size} tip={tip} />
    </div>
  );
};

export default LoadingSpinner;